import { getToken, getUser } from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"

//GET
export const getReceivableAging = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "reports/get_receivables_aging",
      {
        requester: getUser(),
        token: getToken(),
        customer_id: data.customer_id,
        page: data.page,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const emailStatementOfAccount = async (id, file) => {
  const formData = new FormData()
  formData.append("requester", getUser())
  formData.append("token", getToken())
  formData.append("id", id)
  formData.append("attachment", file)

  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "emails/send_soa",
      formData
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
